<div class="ShippingMainContent">

  <div class="overlay" *ngIf="AskForShipmentConnection || ShowEmailSettings || ShowAddNewPartner || ShowCompareShippingCostsContainer;"></div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="AskForShipmentConnection">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="AskForShipmentConnection = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'AskForShipmentConnection' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'AskForShipmentConnectionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="AskForShipmentConnection = false; SelectHistoryTracking(this.CurrentHistoricalShipment, false)">{{ 'DontConnect' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="AskForShipmentConnection = false;SelectHistoryTracking(this.CurrentHistoricalShipment, true);">{{ 'ConnectShipments' | translate }}</button>
    </div>
</div>

    <div class="ComparationContainer animated fadeInDown" *ngIf="this.ShowCompareShippingCostsContainer == true;">
      <div class="ComparationContainerClose" (click)="this.ShowCompareShippingCostsContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="ComparationContainerTitle">
        {{'CompareShippingCosts' | translate}}
      </div>
      <div class="ComparationContainerBody">
        <div class="ComparationRow" *ngFor="let s of this.ComparingShippingDetails;let i = index;" (click)="SelectShippingCompany(s.ShippingCompany); SelectComparingShippingDetailsShippingCompany(s.ShippingCompany);" [ngClass]="{'SelectedShippingCompany': s.ShippingCompany.IsSelected == true}">
          <div class="ComparationRowIcon">
            <i class="material-icons" *ngIf="s.ShippingCompany.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
            <i class="material-icons" *ngIf="s.ShippingCompany.IsSelected == false;">radio_button_off</i>
          </div>
          <div class="ComparationRowImage">
            <img [src]="this.parent.BackendServiceUrl + s.ShippingCompany.ImagePath">
          </div>
          <div class="ComparationRowInfo">
            <p>{{s.ShippingCompany.Name}}</p>
            <p *ngIf="s.Price != null;">{{'ShippingCost' | translate}}:
              <span *ngIf="s.PriceContainsVAT == true;">{{s.Price?.UIVATUnitPrice}} {{s.Price?.Currency?.Name}}</span>
              <span *ngIf="s.PriceContainsVAT != true;">{{s.Price?.UIUnitPrice}} {{s.Price?.Currency?.Name}} {{'Receptions.Table.PriceNOVAT' | translate}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="ComparationContainerCommands">

        <div class="ComparationContainerCommandsRow">
          <div *ngFor="let dir of this.Directions" class="SelectedOption" (click)="SelectShippingDirection(dir);">
            <i class="material-icons" *ngIf="dir.ID == this.ShippingDetails.ShippingDirection?.ID;">check</i>
            <i class="material-icons" *ngIf="dir.ID != this.ShippingDetails.ShippingDirection?.ID;" style="color: #fff;">check</i>
            <span>{{dir.Name}}</span>
          </div>
        </div>

        <div class="ComparationContainerCommandsRow">
          <div *ngFor="let service of this.ShippingServiceTypes" class="SelectedOption" (click)="SelectGeneralShippingServiceType(service);">
            <i class="material-icons" *ngIf="service.IsSelected == true;">check</i>
            <i class="material-icons" *ngIf="service.IsSelected != true;" style="color: #fff;">check</i>
            <span>{{service.Name}}</span>
          </div>
        </div>

        <button mat-raised-button class="CompareButton" [disabled]="this.parent.loading == true" (click)="CompareShippingCosts();" *ngIf="ComparationCompleted != true;">
          <i class="material-icons">local_shipping</i>
          <i class="material-icons">linear_scale</i>
          <span>{{'CompareShippingCosts' | translate}}</span>
        </button>

        <button mat-raised-button class="CompareButton" style="background: #32aa3a;" [disabled]="this.parent.loading == true" (click)="AcceptComparedShippingCompany();" *ngIf="ComparationCompleted == true;">
          <i class="material-icons">check</i>
          <span>{{'ChooseShippingCompany' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="AddNewPartnerContainer animated fadeInDown" *ngIf="ShowAddNewPartner == true;">
        <div class="AddNewPartnerContainerTitle">
          {{'AddNewPartner' | translate}}
        </div>
        <div class="AddNewPartnerContainerClose" (click)="ShowAddNewPartner = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="AddNewPartnerContainerBody">

          <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactCompany" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactPerson" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.VATNumber" matInput>
          </div>
  
          <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.NewPartnerAddress != null && this.NewPartnerAddress?.ID != null && this.Countries?.length > 0;">
            <p class="NewTextBoxContainerTitle">{{'SearchCountries' | translate}}</p>
            <div class="NewTextBoxContainer" style="width: 90%;">
              <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
              <div class="NewTextBoxImageContainer" *ngIf="this.NewPartnerAddress?.Country?.FlagURL?.length > 0;">
                <img [src]="this.NewPartnerAddress.Country.FlagURL">
              </div>
              <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Country.Name" matInput (ngModelChange)="this.countryTermUpdate.next($event)" (click)="InitializeNewAddressCountrySearch();">
              <i class="material-icons" *ngIf="!(this.NewPartnerAddress.Country.Name?.length > 0) && !loadingCountry;">search</i>
              <i class="material-icons" style="color:red;" *ngIf="this.NewPartnerAddress.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectNewAddressCountry();">close</i>
            
              <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries?.length > 0;">
                <div *ngFor="let c of this.FilteredCountries;" class="PartnersSearchResultText" (click)="SelectNewPartnerAddressCountry(c);">
                    <div class="FilteredCountriesImageContainer">
                      <img [src]="c.FlagURL">
                    </div>
                    <div class="FilteredCountriesName">{{c.Name}}</div>
                </div>
              </div>
            </div>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.State" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.City" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.AddressLine" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ZipCode" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Email" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Phone" matInput>
          </div>

        </div>

        <div class="AddNewPartnerContainerCommands">
          <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == false;" (click)="AddNewPartnerFromShippingAddress();">
            <i class="material-icons">check</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>

          <div class="SelectedOptionNotValid" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == false;">
            <i class="material-icons">close</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>

          <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;background: #ddd;color: #aaa;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == true;">
            <i class="material-icons">check</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>
        </div>
    </div>

    <div *ngIf="ShowEmailSettings" class="EmailSettingsContainer animated fadeInDown">
      <div class="EmailSettingsContainerClose" (click)="CloseEmailSettings();">
        <i class="material-icons">close</i>
      </div>
      <div class="EmailSettingsContainerTitle">
        <p>{{'EmailSettings' | translate}}</p>
      </div>
      <div class="EmailSettingsContainerBody">
        <div class="fullWidthContainer">
          <mat-form-field appearance="outline" class="EmailField">
            <mat-label>{{ 'SMTP' | translate }}</mat-label>
            <mat-select disabled="true" name="SMTP" [compareWith]="parent.compareFn" [(ngModel)]="CurrenctSMTP" required>
              <mat-option *ngFor="let s of SMTPConfigs" [value]="s" (click)="ChangeSMTP(s);">
                {{s.SMTPServer}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="fullWidthContainer">
          <mat-form-field appearance="outline" class="EmailField">
            <mat-label>{{ 'SendFrom' | translate }}</mat-label>
            <mat-select name="FromEmail" [compareWith]="parent.compareFn" [(ngModel)]="CurrentSMTPEmail" required>
              <mat-option *ngFor="let e of SMTPEmails" [value]="e">
                {{e.Email}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="SendtoContainer">
          <p class="SendtoContainerTitle">
            {{'SendTo' | translate}}:
          </p>

          <div class="SendtoEmailsContainer">
            <div class="SendtoEmail" *ngFor="let e of this.CurrentPartner.PartnerAgents" (click)="e.IsSelected = !e.IsSelected;">
              <i class="material-icons" *ngIf="e.IsSelected != true;">close</i>
              <i class="material-icons" *ngIf="e.IsSelected == true;" style="color: #32aa3a;">check</i>
              <span>{{e.Email}}</span>
            </div>
          </div>
        </div>

        <div class="SendtoContainer">
          <p class="SendtoContainerTitle">
            {{'SubjectEmail' | translate}}:
          </p>

          <div class="SendtoEmailsContainer">
            <mat-form-field class="EmailFormField" appearance="outline">
              <mat-label>{{ 'SubjectEmail' | translate }}</mat-label>
              <input autocomplete="off" matInput [(ngModel)]="this.EmailMessage.EmailModel.Subject">
            </mat-form-field>

            <mat-form-field appearance="outline" class="EmailFormField">
              <mat-label>{{ 'Message' | translate }}</mat-label>
              <textarea autocomplete="off" matInput
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="10"
                        cdkAutosizeMaxRows="20"
                        [(ngModel)]="this.EmailMessage.EmailModel.DefaultMessage"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="EmailSettingsContainerCommands">
        <button mat-raised-button color="primary" class="SendEmailOKSettings" (click)="CloseEmailSettings();" matTooltip="{{ 'SendEmailUponLabelGeneration' | translate }}" matTooltipClass='neutral-tool-tip-management'>
          <i class="material-icons">verified</i>
          <span>{{'AcceptSettings' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
        <div class="InfoQuestionClose">
          <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
        </div>
        <div class="InfoQuestionTitle">
          {{ 'Configuration.DeleteQuestion' | translate }}
        </div>
        <div class="InfoQuestionBody">
          {{ 'Configuration.DeleteQuestionDescription' | translate }}
        </div>
    
        <div class="InfoQuestionCommands">
          <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
          <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
        </div>
    </div>

    <div class="HalfContentTitle">
        {{'NewShipment' | translate}} - {{this.ShippingDetails?.ShippingCompany.Name}}
    </div>

    <div class="ShippingCompanySelectContainer">
        <div class="ShippingCompany" *ngFor="let s of this.ShippingCompanies;let i = index;" (click)="SelectShippingCompany(s);" [ngClass]="{'SelectedShippingCompany': s.IsSelected == true}">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="s.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="s.IsSelected == false;">radio_button_off</i>
            </div>
            <div class="ShippingCompanyImage">
                <img [src]="this.parent.BackendServiceUrl + s.ImagePath">
            </div>
        </div>

        <div class="SelectedOptionsContainer" *ngIf="!ShippingDetails.TrackingLabel?.length;">
            <div *ngFor="let dir of this.Directions" class="SelectedOption" (click)="SelectShippingDirection(dir);">
                <i class="material-icons" *ngIf="dir.ID == this.ShippingDetails.ShippingDirection?.ID;">check</i>
                <i class="material-icons" *ngIf="dir.ID != this.ShippingDetails.ShippingDirection?.ID;" style="color: #fff;">check</i>
                <span>{{dir.Name}}</span>
            </div>
        </div>
    </div>

    <div class="HalfContent" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && !TaskCompleted;" style="width: 45%;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Receiver' | translate}}</span>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactCompany" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactPerson" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.VATNumber" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Country' | translate}}</p>
        <div class="NewTextBoxContainer">
          <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
          <div class="NewTextBoxImageContainer" *ngIf="this.Left?.Country?.FlagURL?.length > 0;">
            <img [src]="this.Left.Country.FlagURL">
          </div>
          <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Left.Country.Name" matInput (ngModelChange)="this.countryTermUpdate2.next($event)" (click)="InitializeNewCompanyAddressCountrySearch();">
          <i class="material-icons" *ngIf="!(this.Left.Country.Name?.length > 0) && !loadingCountry;">search</i>
          <i class="material-icons" style="color:red;" *ngIf="this.Left.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectNewCompanyAddressCountry();">close</i>
        
          <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries2?.length > 0;">
            <div *ngFor="let c of this.FilteredCountries2;" class="PartnersSearchResultText" (click)="SelectNewCompanyAddressCountry(c);">
                <div class="FilteredCountriesImageContainer">
                  <img [src]="c.FlagURL">
                </div>
                <div class="FilteredCountriesName">{{c.Name}}</div>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.State" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.City" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.AddressLine" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ZipCode" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Email" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Phone" matInput>
        </div>
    </div>

    <div class="HalfContent" style="width: 10%;" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && !TaskCompleted;">
        <div class="SenderTitle">
            <button mat-raised-button color="primary" class="SwitchDirectionButton" (click)="SwitchDirection();">
                <i class="material-icons">compare_arrows</i>
            </button>
        </div>
    </div>

    <div class="HalfContent" style="width: 45%;" *ngIf="!TaskCompleted;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Receiver' | translate}}</span>
            <span *ngIf="this.Right?.ParentPartnerCode?.length > 0;"> ({{this.Right?.ParentPartnerCode}})</span>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.Right != null && this.Right?.ID != null && this.ShippingAddresses?.length > 1;">
          <p class="NewTextBoxContainerTitle" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'PickupAddress' | translate}}</p>
          <p class="NewTextBoxContainerTitle" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'ShippingAddresses' | translate}}</p>
          <div class="NewTextBoxContainer">
            <mat-spinner *ngIf="this.LoadingShippingAddressSelection == true;" class="loadingShippingAddressSpinner" [diameter]="25"></mat-spinner>
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenCloseShowAllAddresses();" [(ngModel)]="this.SelectedAddressLine">
            <i class="material-icons" *ngIf="this.LoadingShippingAddressSelection != true;">keyboard_arrow_down</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.ShowAllAddresses == true;">
              <div *ngFor="let a of this.ShippingAddresses;" class="PartnersSearchResultText" (click)="SelectShippingAddressFromUI(a);">
                <i class="material-icons" *ngIf="a.IsSelected == true;">check</i>
                <span>{{a.Country.ShortName}} - {{a.City}}, {{a.ContactPerson}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;">
            <p class="NewTextBoxContainerTitle">{{'SearchPartners' | translate}}</p>
            <div class="NewTextBoxContainer">
              <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
              <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
              <i class="material-icons" *ngIf="!(this.Filter.SearchTerm?.length > 0) && !loadingShipment;">search</i>
              <i class="material-icons" style="color:red;" *ngIf="this.Filter.SearchTerm?.length > 0 && !loadingShipment;" (click)="DeselectPartner();">close</i>
            
              <div class="CentralSearchResultsContainer" *ngIf="Partners?.length > 0;">
                <div *ngFor="let p of this.Partners;" class="PartnersSearchResultText" (click)="SelectPartner(p);">
                    {{p.Name}}
                </div>
              </div>
            </div>

            <div class="AddNewPartnerWhiteButton" (click)="ShowAddNewPartnerContainer();" *ngIf="(this.Right != null) == false && this.Filter.SearchTerm?.length > 0 && (this.Partners?.length > 0) == false;">
              <i class="material-icons">person_add_alt_1</i>
            </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input type="text" class="NewTextBox" [(ngModel)]="this.Right.ContactPerson" matInput (input)="updateRightChanged();">
        </div>
        </div>
       
        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.VATNumber" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.Right != null && this.Right?.ID != null && this.Countries?.length > 0;">
          <p class="NewTextBoxContainerTitle">{{'SearchCountries' | translate}}</p>
          <div class="NewTextBoxContainer">
            <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
            <div class="NewTextBoxImageContainer" *ngIf="this.Right?.Country?.FlagURL?.length > 0;">
              <img [src]="this.Right?.Country?.FlagURL">
            </div>
            <input (input)="updateRightChanged();" type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Right.Country.Name" matInput (ngModelChange)="this.countryTermUpdate.next($event)" (click)="InitializeCountrySearch();">
            <i class="material-icons" *ngIf="!(this.Right.Country.Name?.length > 0) && !loadingCountry;">search</i>
            <i class="material-icons" style="color:red;" *ngIf="this.Right.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectCountry();">close</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries?.length > 0;">
              <div *ngFor="let c of this.FilteredCountries;" class="PartnersSearchResultText" (click)="SelectCountry(c);updateRightChanged();">
                <div class="FilteredCountriesImageContainer">
                  <img [src]="c.FlagURL">
                </div>
                <div class="FilteredCountriesName">{{c.Name}}</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.State" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.City" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'AddressLine' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.AddressLine" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.ZipCode" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.Email" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.Phone" matInput (input)="updateRightChanged();">
        </div>
        </div>
        
    </div>

    <div class="HalfContent" style="width: 10%;" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && !TaskCompleted;">
        <div class="SenderTitle">
            <button mat-raised-button color="primary" class="SwitchDirectionButton" (click)="SwitchDirection();">
                <i class="material-icons">compare_arrows</i>
            </button>
        </div>
    </div>

    <div class="HalfContent" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && !TaskCompleted;" style="width: 45%;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Receiver' | translate}}</span>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactCompany" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactPerson" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.VATNumber" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Country' | translate}}</p>
        <div class="NewTextBoxContainer" *ngIf="this.Left?.Country?.ID > 0">
            <div class="NewTextBoxImageContainer" *ngIf="this.Left?.Country?.FlagURL?.length > 0;">
              <img [src]="this.Left.Country.FlagURL">
            </div>
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.Country.Name" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.State" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.City" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.AddressLine" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ZipCode" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Email" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Phone" matInput>
        </div>
    </div>

    <div class="TransportSection" *ngIf="this.parent?.Company?.ID > 0 && !TaskCompleted && this.CurrentPartner?.ID != null;">
      <div class="HalfContent" style="width: 45%;min-height: 50px;">
        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.Right?.ID != 0;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">check</i>
          <span>{{'UpdatePartnerAddress' | translate}}</span>
        </button>

        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.Right?.ID == 0;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddNewAddress' | translate}}</span>
        </button>

        <button style="background: #32aa3a;color: #fff;" mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.RightChanged == true;" (click)="this.Right.ID = 0; AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddAsNewAddress' | translate}}</span>
        </button>
     
      </div>

      <div class="HalfContent" style="width: 10%;min-height: 50px;">
       
      </div>

      <div class="HalfContent" style="width: 45%;min-height: 50px;">
        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.Right?.ID != 0;" style="margin-left:6%;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">check</i>
          <span>{{'UpdatePartnerAddress' | translate}}</span>
        </button>

        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.Right?.ID == 0;" style="margin-left:6%;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddNewAddress' | translate}}</span>
        </button>

        <button style="background: #32aa3a;color: #fff;" mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.RightChanged == true;" (click)="this.Right.ID = 0; AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddAsNewAddress' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted && this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes?.length > 0;">
        <div class="SectionTitle">
            {{'ShippingServices' | translate}}
        </div>

        <div class="SelectedOptionsContainer">
            <div *ngFor="let service of this.ShippingDetails.ShippingCompany.ShippingServiceTypes" class="SelectedOption" (click)="SelectShippingServiceType(service);">
                <i class="material-icons" *ngIf="service.IsSelected == true;">check</i>
                <i class="material-icons" *ngIf="service.IsSelected != true;" style="color: #fff;">check</i>
                <span>{{service.Name}}</span>
            </div>
        </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted && this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes?.length > 0;">
      <div class="SectionTitle">
          {{'ShippingResponsability' | translate}}
      </div>

      <div class="SelectedOptionsContainer">
        <mat-form-field style="width: 50%;" appearance="outline">
          <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
          <mat-select name="ShippingResponsability" [compareWith]="compareFn" [(ngModel)]="this.ShippingDetails.ShippingResponsability">
            <mat-option *ngFor="let s of this.ShippingResponsabilities" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;">
        <div class="SectionTitle">
            {{'TransportedBoxesInformation' | translate}}
        </div>

       <div class="BoxesSearchContainer">
        <div class="B2BBodyTopSearchContainer">
          <div class="NewTextBoxContainer" style="margin: 0; width: 25%;">
            <mat-spinner *ngIf="this.HistoryLoading == true;" class="loadingShippingAddressSpinner" [diameter]="25"></mat-spinner>
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenHistoricalShipments();" placeholder="{{this.HistoryPlaceHolder}}">
            <i class="material-icons" *ngIf="this.HistoryLoading != true && this.ShowHistory == false && this.ConnectedShippingToHistoryTracking != true;">search</i>
            <i class="material-icons" *ngIf="this.ShowHistory == true;" (click)="CloseHistoricalShipments();">close</i>
            <i class="material-icons" *ngIf="this.ConnectedShippingToHistoryTracking == true;" (click)="DisconnectTrackingFromHistoricalShipment();">close</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.ShowHistory == true;">
              <div *ngFor="let shipment of this.HistoricalShipments;" class="PartnersSearchResultText">
                  <div class="ShipmentRow" (click)="AskForDocumentConnection(shipment);">
                    <p class="ShipmentRowTitle">{{shipment.TrackingLabel}}</p>
                    <p *ngFor="let box of this.shipment.Boxes;" class="ShipmentBoxRow">{{box.Length}} x {{box.Width}} x {{box.Height}} / {{box.Weight}}KGs</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
       </div>

        <button mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>

        <div class="ParcelContainerHeadder" *ngIf="this.ShippingDetails?.Boxes?.length > 0;">

            <div class="ParcelIndexHeadder">
                <span>#</span>
            </div>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Length' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Width' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Height' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Weight' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Pallet' | translate }}</span>
            </div>
        </div>

        <div class="ParcelContainer" *ngFor="let box of this.ShippingDetails?.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
            <div class="ParcelIndex">
             <i class="material-icons" *ngIf="this.ShippingDetails?.ShippingServiceType?.ID == -1;">local_shipping</i>
             <i class="material-icons" *ngIf="this.ShippingDetails?.ShippingServiceType?.ID == 1;">flight_takeoff</i>
             <span style="float: left;" *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
             <span style="float: left;" *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
             <span style="float: left;">#{{j + 1}}</span>
            </div>
            
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Length' | translate }}*</mat-label>
              <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Width' | translate }}*</mat-label>
              <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Height' | translate }}*</mat-label>
              <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{this.ShippingDetails?.WeightType?.Name}}*</mat-label>
              <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <mat-checkbox class="PalletCheckBox" [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>
    
            <div class="boxStatus" *ngIf="box.ID > 0;">
              <i class="material-icons">check</i>
            </div>
    
            <div class="boxStatus">
              <i class="material-icons" style="color: red;cursor: pointer;" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">close</i>
            </div>
          </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;">
      <div class="SectionTitle">
          {{'AWBCreationSettings' | translate}}
      </div>

      <div class="SelectedOptionsContainer">
          <div *ngFor="let type of this.DownloadTypes" class="SelectedOption" (click)="SelectDownloadType(type);">
              <i class="material-icons" *ngIf="type.ID == this.CreateShippingLabelSettings?.DownloadType?.ID;">check</i>
              <i class="material-icons" *ngIf="type.ID != this.CreateShippingLabelSettings?.DownloadType?.ID;" style="color: #fff;">check</i>
              <span>{{type.Name}}</span>
          </div>
      </div>

      <div class="LabelEmailContainer">
        <mat-slide-toggle [(ngModel)]="this.CreateShippingLabelSettings.SendEmail" (click)="ViewEmailSettings();">{{'SendLabelToPartner' | translate}}</mat-slide-toggle>
      </div>

      <div class="LabelEmailContainer">
        <button mat-raised-button color="primary" class="TransportButton" *ngIf="this.CreateShippingLabelSettings.SendEmail == true;" (click)="ViewEmailSettings();">
          <i class="material-icons">settings</i>
          <span>{{'ViewEmailSettings' | translate}}</span>
        </button>
      </div>
      
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;">
      <button mat-raised-button class="AddressButton" (click)="OpenCompareShippingCosts();">
        <i class="material-icons">local_shipping</i>
        <i class="material-icons">linear_scale</i>
        <span>{{'CompareShippingCosts' | translate}}</span>
      </button>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;margin-top: 25px;">
     
      <button mat-raised-button color="primary" class="BigButton" (click)="SimulateShippingCost();" style="background: #32aa3a;">
        <i class="material-icons" style="color: #000;">start</i>  
        <i class="material-icons" style="color: #000;">payment</i>
        <span>{{'GetShippingCost' | translate}}</span>
      </button>

      <div class="ButtonPressInfo" *ngIf="this.ShippingDetails?.Price != null && this.ShippingDetails?.Price?.UIUnitPrice != null && this.ShippingDetails?.Price?.Currency != null;">
        <i *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == false" (click)="ShowPriceDetails();" class="material-icons">keyboard_arrow_right</i>
        <i *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == true" (click)="ShowPriceDetails();" class="material-icons">keyboard_arrow_down</i>
        <p>{{'ShippingCost' | translate}}: <span>{{this.ShippingDetails?.Price?.UIUnitPrice}} {{this.ShippingDetails?.Price?.Currency?.Name}}</span> [{{'Receptions.Table.PriceNOVAT' | translate}}]</p>
      
        <div *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == true">
          <p class="DetailedShippingPriceEntry" *ngFor="let entry of this.ShippingDetails.DetailedShippingPriceEntries;">
            {{entry?.Index}} - {{entry?.Value}} {{entry?.Currency?.Name}} ({{entry?.Description}})
          </p>
        </div>
      </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;">
      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;" (click)="CreateShippingLabel(false);">
          <i class="material-icons">verified</i>
          <span>{{'GenerateLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == -1;" (click)="CreateShippingLabel(false);">
        <i class="material-icons">verified</i>
          <span>{{'GenerateLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == -1;" (click)="CreateShippingLabel(true);">
          <i class="material-icons">verified</i>
          <i class="material-icons">group_add</i>
          <span>{{'GenerateAndPickup' | translate}}</span>
      </button>
    </div>

    <div class="TransportInfoSection" *ngIf="TaskCompleted == true;">
      <div class="CongratsContainer">
        <i class="material-icons">verified</i>
        <span>{{'ProcessSuccessfullyCompleted' | translate}}</span>
      </div>
      
      <div class="TransportInfoSectionMainMessage">
        <p>{{this.ShippingDetails?.ShippingDetailsText}}</p>
        <p *ngIf="ShippingDetails?.TrackingLabel?.length > 0;">{{ 'TrackingLabel' | translate}}: <span>{{ShippingDetails.TrackingLabel}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.CarrierPickupNumber?.length > 0;">{{ 'PickupNumber' | translate}}: <span>{{ShippingDetails.PickupInformation.CarrierPickupNumber}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupDateUI?.length > 0;">{{ 'PickupDate' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupDateUI}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupEarliestUI?.length > 0;">{{ 'PickupEarliest' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupEarliestUI}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupLatestUI?.length > 0;">{{ 'PickupLatest' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupLatestUI}}</span></p>
        <p *ngIf="ShippingDetails?.ShippingServiceType?.Name?.length > 0;">{{ 'ShippingServiceType' | translate}}: <span>{{ShippingDetails.ShippingServiceType.Name}}</span></p>
        <p *ngIf="ShippingDetails?.ShippingWay?.Name?.length > 0;">{{ 'ShippingWay' | translate}}: <span>{{ShippingDetails.ShippingWay.Name}}</span></p>
      </div>

      <button mat-raised-button color="primary" class="BigButton" (click)="ReDownloadDocuments(1);">
          <i class="material-icons">downloading</i>
          <span>{{'ReDownloadLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" (click)="ReDownloadDocuments(2);">
        <i class="material-icons">local_print_shop</i>
        <span>{{'RePrintLabel' | translate}}</span>
    </button>

    <div style="width: 100%;float: left;margin-top: 50px;">
      <button mat-raised-button color="primary" class="ConclusionButton" (click)="this.parent.ReloadPage();">
        <i class="material-icons">add</i>
        <span>{{'GenerateTrackingLabel' | translate}}</span>
      </button>
    </div>
  </div>
</div>